export default __webpack_public_path__ + "static/media/ChevronLeft.e7c7d098.svg";